<template>
  <div class="comp_sec_tit bg-white" :style="{'font-size':size + 'px'}">
    <span class="title pl10" v-if="border" :style="{'border-left': '3px solid ' + color}">{{title}}</span>
    <span class="title" v-else>{{title}}</span>
    <slot name="label">
      <small class="f14 grayb" v-if="label">{{label}}</small>
    </slot>
    <slot name="btn"></slot>
  </div>
</template>

<script>
  export default {
    name: 'CSectionTitle',
    props: {
      title: {
        type: String,
        default: 'section-标题'
      },
      border: {
        type: Boolean,
        default: true
      },
      size: {
        type: Number,
        required: false,
        default: 22
      },
      color: {
        type: String,
        default: '#00AAFF'
      },
      vip: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        required: false
      }
    }
  }
</script>

<style lang="less">
  @import '../styles/_mixins-wln';

  .comp_sec_tit {
    padding: 1em 10px 1em 0;

    .title {
      font-weight: bold;
    }

    .vip {
      img {
        width: 12px;
      }
    }
  }

</style>
